
import React from 'react';
import { EnhancedLabel } from '@/lib/shadcn-enhanced';
import { Textarea } from '@/components/ui/textarea';
import SpeechToTextInput from './SpeechToTextInput';

interface AnswerSectionProps {
  answer: string;
  setAnswer: (value: string) => void;
  wordCount: number;
}

const AnswerSection: React.FC<AnswerSectionProps> = ({
  answer,
  setAnswer,
  wordCount
}) => {
  const handleTranscript = (transcript: string) => {
    setAnswer(transcript);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-1">
        <EnhancedLabel htmlFor="answer">Ditt svar</EnhancedLabel>
        <span className="text-sm text-gray-500">{wordCount} ord</span>
      </div>
      <div className="flex items-center justify-end gap-2 mb-2">
        <SpeechToTextInput onTranscript={handleTranscript} />
      </div>
      <Textarea
        id="answer"
        placeholder="Skriv ditt svar her..."
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
        rows={10}
        className="resize-y"
        required
      />
    </div>
  );
};

export default AnswerSection;
